import { formatDate } from '@/scopes/account/common/formatters'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { mqMin, space, tok, tokPx } from '@sunwebgroup/ui-components'
import { Icon, Typography } from '@sunwebgroup/ui-components/uds'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'
import { useBookingsOverviewStore } from '../../infrastructure/useBookingsOverviewStore'
import { getVouchers } from '../selectors'
import { VoucherCard } from './VoucherCard'

const Title = styled(Typography)`
  ${Typography.modVariant('display-h-regular')};
  color: ${tok('semantics_content_color')};

  @media ${mqMin('primitives_breakpoint_l_min')} {
    ${Typography.modVariant('display-g-regular')};
  }
`

const Heading = styled.div`
  display: flex;
  align-items: center;
  gap: ${space('primitives_space_8')};
  margin-bottom: ${space('primitives_space_12')};
`

const VouchersGrid = styled.div`
  display: grid;
  gap: ${tokPx('primitives_space_16')};
  margin-top: ${tokPx('primitives_space_24')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    grid-template-columns: repeat(auto-fill, minmax(${tokPx('primitives_area_size_280')}, 1fr));
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    grid-template-columns: repeat(3, 1fr);
  }
`

export function Vouchers({ className }: { className?: string }) {
  const intl = useIntl()
  const locale = useConfiguration('locale')
  const vouchers = useBookingsOverviewStore(getVouchers)

  if (vouchers.length === 0) {
    return null
  }

  return (
    <div className={className}>
      <Heading>
        <Icon glyph="Ticket" size={24} />
        <Title>{intl.formatMessage({ id: 'bookings_overview_vouchers_title' })}</Title>
      </Heading>
      <Typography variant="body-m-regular-snug">
        {intl.formatMessage({ id: 'bookings_overview_vouchers_description' })}
      </Typography>
      <VouchersGrid>
        {vouchers.map(voucher => (
          <VoucherCard
            key={voucher.voucherCode}
            value={voucher.amount}
            expirationDate={formatDate(voucher.expirationDate, locale)}
            link={voucher.voucherCode}
          />
        ))}
      </VouchersGrid>
    </div>
  )
}
